import { TdsCard } from '@scania/tegel-react'
import styled from 'styled-components'

export const StyledDeviationCard = styled(TdsCard)`
  tds-card::part(body-img) {
    width: 100% !important;
    aspect-ratio: 16 / 9 !important;
    object-fit: cover !important;
    object-position: center !important;
  }
`
